(() => {
  const ROOT_SELECTOR =
    '[data-mr-main-cart]';

  const getRoot = () => {
    return document.querySelector(
      ROOT_SELECTOR
    );
  };

  const setLoading = (loading) => {
    getRoot()?.classList.toggle(
      'is-loading',
      loading
    );
  };

  const changeCartLine = async (
    key,
    quantity
  ) => {
    const shopRoot =
      window.Shopify?.routes?.root || '/';

    setLoading(true);

    try {
      const response = await fetch(
        `${shopRoot}cart/change.js`,
        {
          method: 'POST',
          headers: {
            'Content-Type':
              'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: key,
            quantity
          })
        }
      );

      if (!response.ok) {
        throw new Error(
          'Unable to update cart.'
        );
      }

      window.location.reload();
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const addRecommendation = async (
    variantId,
    button
  ) => {
    const shopRoot =
      window.Shopify?.routes?.root || '/';

    if (
      !variantId ||
      !button ||
      button.disabled
    ) {
      return;
    }

    const originalText =
      button.textContent;

    button.disabled = true;
    button.textContent = 'ADDING…';

    setLoading(true);

    try {
      const response = await fetch(
        `${shopRoot}cart/add.js`,
        {
          method: 'POST',
          headers: {
            'Content-Type':
              'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(variantId),
                quantity: 1
              }
            ]
          })
        }
      );

      if (!response.ok) {
        throw new Error(
          'Unable to add product.'
        );
      }

      window.location.reload();
    } catch (error) {
      console.error(error);

      button.disabled = false;
      button.textContent = originalText;

      setLoading(false);
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      const item = event.target.closest(
        '[data-mr-main-cart-item]'
      );

      if (item) {
        const key = item.dataset.cartKey;

        const input = item.querySelector(
          '[data-mr-main-cart-quantity]'
        );

        const currentQuantity =
          Number(input?.value) || 0;

        if (
          event.target.closest(
            '[data-mr-main-cart-decrease]'
          )
        ) {
          changeCartLine(
            key,
            Math.max(
              0,
              currentQuantity - 1
            )
          );

          return;
        }

        if (
          event.target.closest(
            '[data-mr-main-cart-increase]'
          )
        ) {
          changeCartLine(
            key,
            currentQuantity + 1
          );

          return;
        }

        if (
          event.target.closest(
            '[data-mr-main-cart-remove]'
          )
        ) {
          changeCartLine(
            key,
            0
          );

          return;
        }
      }

      const recommendationButton =
        event.target.closest(
          '[data-mr-main-cart-recommendation-add]'
        );

      if (!recommendationButton) return;

      const card =
        recommendationButton.closest(
          '[data-mr-main-cart-recommendation]'
        );

      const selector = card?.querySelector(
        '[data-mr-main-cart-recommendation-variant]'
      );

      const variantId =
        selector?.value ||
        recommendationButton.dataset.variantId;

      addRecommendation(
        variantId,
        recommendationButton
      );
    }
  );

  document.addEventListener(
    'change',
    (event) => {
      const input = event.target.closest(
        '[data-mr-main-cart-quantity]'
      );

      if (!input) return;

      const item = input.closest(
        '[data-mr-main-cart-item]'
      );

      const key =
        item?.dataset.cartKey;

      const quantity = Math.max(
        0,
        Number(input.value) || 0
      );

      if (key) {
        changeCartLine(
          key,
          quantity
        );
      }
    }
  );
})();
